const SOCCER_PINGOAL_LEAGUE_GROUP_ID = 113;
const BASKETBALL_PINGOAL_LEAGUE_GROUP_ID = 122;
const ESPORT_PINGOAL_LEAGUE_GROUP_ID = [151, 215];

const LEAGUE_GROUP_ID_LIST = [SOCCER_PINGOAL_LEAGUE_GROUP_ID, BASKETBALL_PINGOAL_LEAGUE_GROUP_ID, ESPORT_PINGOAL_LEAGUE_GROUP_ID];

const SOCCER_SPORT_ID = 1;
const BASKETBALL_SPORT_ID = 2;
const ESPORT_SPORT_ID = 43;

const SPORT_ID_LIST = [SOCCER_SPORT_ID, BASKETBALL_SPORT_ID, ESPORT_SPORT_ID];

const SPORT_ID_LEAGUE_GROUP_ID_MAPPING = {
	1: SOCCER_PINGOAL_LEAGUE_GROUP_ID,
	2: BASKETBALL_PINGOAL_LEAGUE_GROUP_ID,
	43: ESPORT_PINGOAL_LEAGUE_GROUP_ID,
};

const SOCCER_PINGOAL_KEY = 'soccer_pingoal';
const BASKET_PINGOAL_KEY = 'basketball_pingoal';
const ESPORT_PINGOAL_KEY = 'esport_pingoal'
const ALL_PINGOAL_NAME_KEY = 'lbl_SabaPinG';
const ALL_PINGOAL_PAGE_LIST = [SOCCER_PINGOAL_KEY, BASKET_PINGOAL_KEY, ESPORT_PINGOAL_KEY];

const ALL_PINGOAL_PAGE_ENTRANCE = {
	name: 'lbl_SabaPinG',
	iconClass: 'sport97',
	navigateKey: `#Sports/s=1_0&d=l&lgid=113&allpage=${SOCCER_PINGOAL_KEY}`,
	isNew: { endDate: '2022/7/16' },
};

const ALL_PINGOAL_PAGE_INFO = {
	soccer_pingoal: {
		name: 'lbl_SoccerPinG',
		iconClass: 'sport97-1',
		img: '/Content/SiteSkin/_global/common/images/Pingoal/soccer_pingoal',
		navigateKey: `#Sports/s=1_0&d=l&lgid=113&allpage=${SOCCER_PINGOAL_KEY}`,
		isNew: { endDate: '2022/7/16' },
		leagueId: 102169,
		sportId: 1,
	},
	basketball_pingoal: {
		name: 'lbl_BsktbPinG',
		iconClass: 'sport97-3',
		img: '/Content/SiteSkin/_global/common/images/Pingoal/basketball_pingoal',
		navigateKey: `#Sports/s=2_0&d=l&lgid=122&allpage=${BASKET_PINGOAL_KEY}`,
		isNew: { endDate: '2022/7/16' },
		sportId: 2,
	},
	esport_pingoal: {
		name: 'lbl_EsportsPinG',
		iconClass: 'sport97-4',
		img: '/Content/SiteSkin/_global/common/images/Pingoal/esports_pingoal',
		navigateKey: `#Sports/s=43_0&d=l&lgid=151&allpage=${ESPORT_PINGOAL_KEY}`,
		isNew: { endDate: '2023/5/28' },
		sportId: ESPORT_SPORT_ID,
	}
};

const PINGOAL_KEY_SPORT_ID_MAPPING = {
	soccer_pingoal: SOCCER_SPORT_ID,
	soccer_pingoal_max: SOCCER_SPORT_ID,
	basketball_pingoal: BASKETBALL_SPORT_ID,
	esport_pingoal: ESPORT_SPORT_ID,
};

const ALL_PINGOAL_PAGE_MENU_INDEX = 8;
const ALL_PINGOAL_PAGE_VALUE = '1_0_0_pingoal';
const ALL_PINGOAL_PAGE_CANSEE_KEY = 'CanSeeAllPinGoal';
const BETTYPE_ID_SEQUE_LITE = {
	1: [1, 3, 461, 462, 2],
	2: [1, 3, 401, 402, 2],
	43: [20, 3], // TODO: 待確認
};
const BETTYPE_ID_SEQUE_STANDARD = {
	1: [461, 462, 2],
	2: [401, 402, 2],
	43: [3, 20], // TODO: 待確認
};
const PINGOAL_THEME_CLASS_MAPPING = {
	81055: 'soccer',
	99151: 'soccer',
	102169: 'soccer',
	81080: 'worldcup',
	102463: 'worldcup',
	102482: 'worldcup',
	81081: 'beach',
	102464: 'beach',
	102483: 'beach',
	81082: 'snow',
	102465: 'snow',
	102484: 'snow',
	81287: 'max',
	107612: 'max',
	107613: 'max',
	81288: 'street-football',
	108855: 'street-football',
	108856: 'street-football',
	81289: 'black-gold',
	109262: 'black-gold',
	109264: 'black-gold',
	81296: 'basketball-pingoal-nba',
	111580: 'basketball-pingoal-nba',
	111581: 'basketball-pingoal-nba',
	114676: 'basketball-pingoal-nba',
	114646: 'basketball-pingoal-nba',
	81302: 'basketball-pingoal-cba',
	112123: 'basketball-pingoal-cba',
	112124: 'basketball-pingoal-cba',
	114677: 'basketball-pingoal-cba',
	114647: 'basketball-pingoal-cba',
	81303: 'basketball-pingoal-world-cup',
	112125: 'basketball-pingoal-world-cup',
	112128: 'basketball-pingoal-world-cup',
	114678: 'basketball-pingoal-world-cup',
	114648: 'basketball-pingoal-world-cup',
	81311: 'basketball-pingoal-nba-dynasty',
	117109: 'basketball-pingoal-nba-dynasty',
	117110: 'basketball-pingoal-nba-dynasty',
	117111: 'basketball-pingoal-nba-dynasty',
	117112: 'basketball-pingoal-nba-dynasty',
	81316: 'esports-pingoal-lol-worlds',
	121757: 'esports-pingoal-lol-worlds',
	121760: 'esports-pingoal-lol-worlds',
	81317: 'esports-pingoal-lol-spring',
	121758: 'esports-pingoal-lol-spring',
	121761: 'esports-pingoal-lol-spring',
	81318: 'esports-pingoal-lol-summer',
	121759: 'esports-pingoal-lol-summer',
	121762: 'esports-pingoal-lol-summer',
};

export const pingoalSetting = {
	SOCCER_PINGOAL_LEAGUE_GROUP_ID,
	BASKETBALL_PINGOAL_LEAGUE_GROUP_ID,
	ESPORT_PINGOAL_LEAGUE_GROUP_ID,
	LEAGUE_GROUP_ID_LIST,
	SPORT_ID_LIST,
	SPORT_ID_LEAGUE_GROUP_ID_MAPPING,
	ALL_PINGOAL_NAME_KEY,
	ALL_PINGOAL_PAGE_LIST,
	ALL_PINGOAL_PAGE_ENTRANCE,
	ALL_PINGOAL_PAGE_INFO,
	PINGOAL_KEY_SPORT_ID_MAPPING,
	ALL_PINGOAL_PAGE_MENU_INDEX,
	ALL_PINGOAL_PAGE_VALUE,
	ALL_PINGOAL_PAGE_CANSEE_KEY,
	BETTYPE_ID_SEQUE_LITE,
	BETTYPE_ID_SEQUE_STANDARD,
	PINGOAL_THEME_CLASS_MAPPING,
}